export default __webpack_public_path__ + "static/byod-check-list-47bc3597be1097aa6b4c7f5233656454.pdf";